import db from '@/plugins/dexie';
import obterUltimaDataTabela from '@/utils/obterUltimaDataTabela';

export default {
  namespaced: true,

  state: {
    list: [],
    cache_movimentacaoveiculo: [],
    cache_veiculo: [],
    cache_eventosveiculos: [],
    cache_itemmovimentacaoveiculo: [],
    cache_veiculoatividade: [],
    arrayDataAtualizacao: [],
    primeiroUpdate: false,
  },

  getters: {
    list: (state) => state.list,
    arraydata: (state) => state.arrayDataAtualizacao,
    primeiroUpdate: (state) => state.primeiroUpdate,
  },

  actions: {
    async esvaziarCache({ commit, state }, payload) {
      if (payload.att && db[payload.tabela]) {
        try {
          const itemAtual = state.arrayDataAtualizacao.find(
            (item) => item.tabelaApp === payload.tabela || item.tabela === payload.tabela,
          );
          const dataAtual = itemAtual?.data;

          const dataattFormatada = await obterUltimaDataTabela(payload.tabela, payload.att);
          if (dataattFormatada && !dataattFormatada.startsWith('1997-01-01')) {
            const tsNovo = new Date(dataattFormatada).getTime();
            const tsAtual = dataAtual ? new Date(dataAtual).getTime() : -Infinity;

            if (!dataAtual || dataAtual.startsWith('1997-01-01') || (!Number.isNaN(tsNovo) && tsNovo > tsAtual)) {
              commit('SET_ATUALIZA_DATA', {
                tabela: payload.tabela,
                data: dataattFormatada,
              });
            }
          }
        } catch (err) {
          console.warn(`Erro ao obter ultima data em ${payload.tabela}:`, err);
        }
      }
      commit('EMPTY_CACHE', payload.tabela);
    },

    async setCache({ commit }, payload) {
      commit('SET_CACHE', payload);
    },

    async pushCache({ commit, state }, payload) {
      if (state[`cache_${payload.tabela}`]?.length > 0) {
        commit('PUSH_CACHE', payload);
      }
    },

    async getCache({ state }, tabela) {
      return state[`cache_${tabela}`]?.length || 0;
    },

    async atualizaData({ commit }, atualizar) {
      commit('SET_ATUALIZA_DATA', atualizar);
    },

    async primeiroUpdate({ commit }, estado) {
      commit('SET_PRIMEIRO_UPDATE', estado);
    },

    async reloadCache({ commit }, tabela) {
      if (db[tabela]) {
        const dados = await db[tabela].toArray();
        commit('SET_CACHE', { tabela, dados });
      }
    },
  },

  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
    EMPTY_CACHE(state, tabela) {
      if (state[`cache_${tabela}`]) {
        state[`cache_${tabela}`] = [];
      }
    },
    SET_CACHE(state, payload) {
      state[`cache_${payload.tabela}`] = payload.dados ?? [];
    },
    PUSH_CACHE(state, payload) {
      if (state[`cache_${payload.tabela}`]) {
        state[`cache_${payload.tabela}`].push(...payload.novosItens);
      }
    },
    SET_CACHE_ARRAYDATA(state, arraydata) {
      state.arrayDataAtualizacao = arraydata ?? [];
    },
    SET_ATUALIZA_DATA(state, atualizar) {
      state.arrayDataAtualizacao.forEach((item, index) => {
        if (item.tabelaApp === atualizar.tabela || item.tabela === atualizar.tabela) {
          const dataAtual = item.data;
          const dataNova = atualizar.data;
          if (!dataNova) return;
          if (!dataAtual || dataAtual.startsWith('1997-01-01')) {
            state.arrayDataAtualizacao[index].data = dataNova;
          } else {
            const tsAtual = new Date(dataAtual).getTime();
            const tsNovo = new Date(dataNova).getTime();
            if (!Number.isNaN(tsNovo) && (!Number.isNaN(tsAtual) ? tsNovo >= tsAtual : true)) {
              state.arrayDataAtualizacao[index].data = dataNova;
            }
          }
        }
      });
    },
    SET_PRIMEIRO_UPDATE(state, estado) {
      state.primeiroUpdate = estado ?? false;
    },
  },
};
